// Global
import React from 'react';

// Local
import { HeroCardAlignment, HeroType } from 'lib/services/models/types';
import { HeroSimple } from './HeroSimple/HeroSimple';
import { HeroArticle } from './HeroArticle/HeroArticle';
import { HeroGeneral } from './HeroGeneral/HeroGeneral';
import { HeroAlternate } from './HeroAlternate/HeroAlternate';
import { Themes } from 'lib/themes';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { ActionItem } from 'components/helpers/ActionToolbar';

export interface HeroProps {
  theme: Themes;
  heroVariant: HeroType;
  contentPosition: HeroCardAlignment;
  contentEyebrow?: React.ReactNode;
  contentHeadline: React.ReactNode;
  contentDescription?: React.ReactNode;
  cta1?: React.ReactNode;
  cta2?: React.ReactNode;
  externalPageImage?: React.ReactNode | undefined;
  contentPageImage?: React.ReactNode;
  isImagePresent?: boolean;
  authorName?: string;
  authorProfileURL?: string;
  hideAuthorBySignaturePrefix?: boolean;
  PublishDate?: React.ReactNode; //This PublishedDate from content-site
  SEOModifiedDate?: React.ReactNode; //This SEOModifiedDate from content-site
  DisplayDate?: React.ReactNode;
  editingHelpText?: React.ReactNode;

  // ActionToolbar props
  heroActionToolbarButtons?: ActionItem[];
  heroActionToolbarIdentifier?: string;
  disableHeroActionToolbar?: boolean;
  isArticlePage?: boolean;
}

export const Hero = (props: HeroProps) => {
  /*
   * Rendering
   */
  const HeroComponent = getHeroVariant(props?.heroVariant);
  return (
    <BrandAndThemeProvider theme={props.theme} data-component="authorable/shared/content/hero/hero">
      <HeroComponent {...props} />
    </BrandAndThemeProvider>
  );
};

function getHeroVariant(heroType: HeroType): React.ComponentType<HeroProps> {
  switch (heroType) {
    case 'General':
      return HeroGeneral;
    case 'Alternate':
      return HeroAlternate;
    case 'Simple':
      return HeroSimple;
    case 'Article':
      return HeroArticle;
    default:
      return HeroGeneral;
  }
}
